import { createSlice } from "@reduxjs/toolkit";

/** Which step of "default sectors or define them in a table" the create flow is on. */
export type SectorSourceStep = "none" | "choosing" | "table";

interface LighthouseState {
    isShowingIALAWarning: boolean;
    isSectorTableOpen: boolean;
    /** The definition table, opened from the sector editor to edit an existing lighthouse. */
    isSectorEditTableOpen: boolean;
    isSectorEditorOpen: boolean;
    lighthouseTableSelectedSector: number | null;
    currentLighthouseTrueNorth: number;
    isSavingLighthouse: boolean;
    showSectorColors: boolean;
    sectorOpacity: number;
    isDrawing: boolean;
    isEditing: boolean;
    sectorSourceStep: SectorSourceStep;
    /**
     * Globalids of the edited lighthouse's sectors in numbering order, snapshotted when editing
     * starts and after a save, so sector lists and numbers do not reorder while the user edits.
     */
    sectorOrder: string[] | null;
}

const initialState: LighthouseState = {
    isShowingIALAWarning: false,
    isSectorTableOpen: false,
    isSectorEditTableOpen: false,
    isSectorEditorOpen: false,
    lighthouseTableSelectedSector: null,
    currentLighthouseTrueNorth: 0,
    isSavingLighthouse: false,
    showSectorColors: false,
    sectorOpacity: 0.5,
    isDrawing: false,
    isEditing: false,
    sectorSourceStep: "none",
    sectorOrder: null,
};

const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        setIsShowingIALAWarning(state, action) {
            state.isShowingIALAWarning = action.payload;
        },
        setIsSectorTableOpen(state, action) {
            state.isSectorTableOpen = action.payload;
        },
        setIsSectorEditTableOpen(state, action) {
            state.isSectorEditTableOpen = action.payload;
        },
        setIsSectorEditorOpen(state, action) {
            state.isSectorEditorOpen = action.payload;
        },
        setLighthouseTableSelectedSector(state, action) {
            state.lighthouseTableSelectedSector = action.payload;
        },
        setCurrentLighthouseTrueNorth(state, action) {
            state.currentLighthouseTrueNorth = action.payload;
        },
        setIsSavingLighthouse(state, action) {
            state.isSavingLighthouse = action.payload;
        },
        setShowSectorColors(state, action) {
            state.showSectorColors = action.payload;
        },
        setSectorOpacity(state, action) {
            state.sectorOpacity = action.payload;
        },
        setIsDrawing(state, action) {
            state.isDrawing = action.payload;
        },
        setIsEditing(state, action) {
            state.isEditing = action.payload;
        },
        setSectorSourceStep(state, action) {
            state.sectorSourceStep = action.payload;
        },
        setSectorOrder(state, action) {
            state.sectorOrder = action.payload;
        },
    },
});

export default searchSlice.reducer;
export const {
    setIsShowingIALAWarning,
    setIsSectorTableOpen,
    setIsSectorEditTableOpen,
    setIsSectorEditorOpen,
    setLighthouseTableSelectedSector,
    setCurrentLighthouseTrueNorth,
    setIsSavingLighthouse,
    setShowSectorColors,
    setSectorOpacity,
    setIsDrawing,
    setIsEditing,
    setSectorSourceStep,
    setSectorOrder,
} = searchSlice.actions;
export type { LighthouseState };
